import React from "react";

const Footer: React.FC = () => {
  const contactInfo = [
    {
      icon: (
        <svg
          className="w-8 h-8 text-white"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </svg>
      ),
      title: "E-mail:",
      content: "info@ekumfiengineering.com",
    },
    {
      icon: (
        <svg
          className="w-8 h-8 text-white"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>
      ),
      title: "Address:",
      content: "Atta-Mills Street, Ekumfi Essuehyia, Central Region, GH",
    },
    {
      icon: (
        <svg
          className="w-8 h-8 text-white"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
        </svg>
      ),
      title: "Phone:",
      content: "024-086-5997",
    },
  ];

  const engineeringKeystones = [
    "Research & Development",
    "Farm Machinery & Food Processing",
    "Energy Engineering",
    "Boats & Yachts Building",
    "Wood Works Engineering",
    "Plumbing Engineering",
    "Sustainable Building",
    "TVET/Skills Training",
    "Software & Machine Learning"
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        {/* Contact Info Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-12 border-b border-gray-800">
          {contactInfo.map((info, index) => (
            <div key={index} className="flex items-center space-x-4">
              {/* Icon Container */}
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center">
                  {info.icon}
                </div>
              </div>

              {/* Text Content */}
              <div>
                <h3 className="text-gray-400 text-sm">{info.title}</h3>
                <p className="text-white">{info.content}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Links Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 py-12">
          {/* About Column */}
          <div>
            <h3 className="text-xl font-semibold mb-4">About Ekumfi Engineering</h3>
            <p className="text-gray-400 text-sm">
              A comprehensive engineering conglomerate driving the industrialization of Ekumfiman through nine specialized engineering keystones. 
              We're building a self-sustainable environment that spearheads population-driven development.
            </p>
            <div className="mt-4">
              <p className="text-orange-400 text-sm font-semibold">Mission:</p>
              <p className="text-gray-400 text-sm">To industrialize Ekumfiman through engineering excellence.</p>
            </div>
          </div>

          {/* Engineering Keystones Column */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Engineering Keystones</h3>
            <ul className="space-y-2">
              {engineeringKeystones.slice(0, 5).map((keystone, index) => (
                <li
                  key={index}
                  className="flex items-center text-gray-400 hover:text-orange-500"
                >
                  <svg
                    className="w-4 h-4 mr-2 text-orange-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                  {keystone}
                </li>
              ))}
            </ul>
          </div>

          {/* More Keystones Column */}
          <div>
            <h3 className="text-xl font-semibold mb-4">More Services</h3>
            <ul className="space-y-2">
              {engineeringKeystones.slice(5).map((keystone, index) => (
                <li
                  key={index}
                  className="flex items-center text-gray-400 hover:text-orange-500"
                >
                  <svg
                    className="w-4 h-4 mr-2 text-orange-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                  {keystone}
                </li>
              ))}
            </ul>
          </div>

          {/* Vision & Impact Column */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Vision & Impact</h3>
            <div className="space-y-4">
              <div>
                <p className="text-orange-400 text-sm font-semibold">Vision:</p>
                <p className="text-gray-400 text-sm">
                  To create a unique self-sustainable environment that spearheads population-driven development.
                </p>
              </div>
              <div>
                <p className="text-orange-400 text-sm font-semibold">Impact Areas:</p>
                <ul className="text-gray-400 text-sm space-y-1">
                  <li>• Economic Growth</li>
                  <li>• Community Empowerment</li>
                  <li>• Environmental Sustainability</li>
                  <li>• Skills Development</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="py-6 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-2 text-sm mb-4 md:mb-0">
            <p className="text-gray-400">
              <span className="text-orange-500">Ekumfi Engineering</span> © All
              rights reserved.
            </p>
            <span className="text-gray-400">•</span>
            <a href="/terms" className="text-gray-400 hover:text-white">
              Terms & Conditions
            </a>
          </div>
          <div className="flex space-x-4">
            <a href="#" className="text-gray-400 hover:text-white">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-white">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-white">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-white">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
